<template>
  <div>
    <b-button
      v-b-modal.modal-create-up-caveat
      variant="outline-primary"
      @click="initialSetup"
    >
      Create New
    </b-button>

    <b-modal
      id="modal-create-up-caveat"
      title="Create New Tracker"
      no-close-on-backdrop
      centered
      ok-title="submit"
      cancel-variant="outline-secondary"
    >
      <b-card-text>
        <b-overlay
          :show="$store.state.firTrackerStore.isNewFIRLoading"
          rounded="sm"
          variant="transparent"
          opacity="0.5"
          blur="2px"
        >
          <validation-observer ref="matterForm" #default="{ invalid }">
            <b-form @submit.prevent="addTracker">
              <!-- Select Court -->
              <validation-provider
                #default="{ errors }"
                name="Court"
                vid="court"
                rules="required"
              >
                <b-form-group label="Select Court" label-for="court">
                  <v-select
                    v-model="CourtSelected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="CourtOption"
                    label="text"
                    placeholder="Select Court"
                    @input="onCourtSelect"
                  />
                </b-form-group>
              </validation-provider>

              <!-- Show Diary Number only if special court -->
              <template v-if="CourtSelected && CourtSelected.value === '641852cdefd5bd6acb218575'">
                <validation-provider
                  #default="{ errors }"
                  name="Diary Number"
                  vid="diary-no"
                  rules="required"
                >
                  <b-form-group label-for="diary-no" label="Diary Number">
                    <b-form-input
                      id="diary-no"
                      v-model="DiaryNumber"
                      placeholder="Enter Diary Number"
                    />
                  </b-form-group>
                </validation-provider>
              </template>

              <!-- Otherwise show default fields -->
              <template v-else>
                <validation-provider
                  #default="{ errors }"
                  name="District"
                  vid="district"
                  rules="required"
                >
                  <b-form-group label="Select District" label-for="district">
                    <v-select
                      v-model="DistrictSelected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="DistrictOptions"
                      label="name"
                      placeholder="Select District"
                      @input="onDistrictSelect"
                    />
                  </b-form-group>
                </validation-provider>

                <validation-provider
                  #default="{ errors }"
                  name="Petitioner Name"
                  vid="petitioner-name"
                  rules="required"
                >
                  <b-form-group
                    label-for="petitioner-name"
                    label="Party/Petitoner/Respondent Name"
                  >
                    <b-form-input
                      id="petitioner-name"
                      v-model="PetitionerName"
                      placeholder="Party/Petitoner/Respondent Name"
                    />
                  </b-form-group>
                </validation-provider>
              </template>
            </b-form>
          </validation-observer>

          <template #overlay>
            <div class="text-center">
              <b-spinner variant="secondary"></b-spinner>
              <p id="cancel-label">{{ loadingMsg }}</p>
            </div>
          </template>
        </b-overlay>
      </b-card-text>

      <!-- Footer -->
      <template #modal-footer>
        <div class="w-100">
          <div>
            <div>
              <b-button
                variant="primary"
                class="float-right"
                type="submit1"
                :disabled="$store.state.upCaveatStore.isNewFIRLoading"
                @click="addTracker"
              >
                Submit
              </b-button>
            </div>
            <div>
              <b-button
                variant="outline-dark"
                class="float-right mr-1 ml-1"
                type="cancel"
                @click="$bvModal.hide('modal-create-up-caveat')"
              >
                Cancel
              </b-button>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BCardText,
  BFormTextarea,
  BFormGroup,
  BTabs,
  BTab,
  BOverlay,
  BFormRadio,
  BSpinner,
  BFormInvalidFeedback,
  BFormDatepicker,
  BListGroup,
  BListGroupItem
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import axios from 'axios'

export default {
  components: {
    BButton,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormTextarea,
    BCardText,
    BFormInvalidFeedback,
    BFormGroup,
    BTab,
    BTabs,
    vSelect,
    BFormRadio,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
    BSpinner,
    BFormDatepicker,
    BListGroup,
    BListGroupItem
  },
  directives: {
    'b-modal': VBModal,
    Ripple
  },
  data() {
    return {
      CourtSelected: null,
      CourtOption: null,
      PetitionerName: null,
      DistrictOptions: [],
      DistrictSelected: null,
      DiaryNumber: null,
      loadingMsg: '',
      required
    }
  },
  props: ['refreshList'],
  methods: {
    getCourts() {
      let allC = []
      const ll = this.$store.state.courtStore.courtsData
      if (ll) {
        const hcl = ll.highCourts
          .filter(k => k.enabled && k.caveat_section_enabled)
          .map(k => ({
            value: k._id,
            text: k.title,
            cslug: k.cli_slug,
            unique_id: k.unique_id
          }))
        const dcl = ll.districtCourts
          .filter(k => k.enabled && k.caveat_section_enabled)
          .map(k => ({
            value: k._id,
            text: k.title,
            cslug: k.cli_slug,
            unique_id: k.unique_id
          }))
        allC = [...hcl, ...dcl]
      }
      this.CourtOption = allC
    },
    initialSetup() {
      this.CourtSelected = null
      this.PetitionerName = null
      this.DistrictOptions = []
      this.DistrictSelected = null
      this.DiaryNumber = null
    },
    addTracker(event) {
      this.loadingMsg = 'Please Wait, Adding Tracker!'
      event.preventDefault()

      this.$refs.matterForm.validate().then(success => {
        if (!success) return

        if (this.CourtSelected.value === '641852cdefd5bd6acb218575') {

          // let data = {
          //   court_id: this.CourtSelected.value,
          //    diary_no: this.DiaryNumber,
          //   // user_id: '631cab0d340260a941f1aeb0'
          // }

          store.dispatch('caveat_tracker', {
            ctx: this,
            payload: data
          }).then(response => {
            if (response && response.success) {
              this.refreshList()
            }
          })
          // Special court → diary_no API
          // axios.post('http://127.0.0.1:10001/api/caveat_tracker', {
          //   diary_no: this.DiaryNumber,
          //   court_id: this.CourtSelected.value,
          //   user_id: '631cab0d340260a941f1aeb0'
          // }).then(res => {
          //   console.log('Diary API Response', res.data)
          //   this.refreshList()
          // }).catch(err => {
          //   console.error(err)
          // })
        } else {
          // Default tracker API
          let data = {
            court_id: this.CourtSelected.value,
            petitioner_name: String(this.PetitionerName),
            district: String(this.DistrictSelected?.value)
          }
          store.dispatch('upCaveatStore/addTracker', {
            ctx: this,
            payload: data
          }).then(response => {
            if (response && response.success) {
              this.refreshList()
            }
          })
        }
      })
    },
    onCourtSelect(selected) {
      this.CourtSelected = selected
      console.log('Court selected:', selected)
      // Example reset logic
      this.DistrictSelected = null
    },
    onDistrictSelect(selected) {
      this.DistrictSelected = selected
      console.log('District selected:', selected)
    }
  },
  beforeMount() {
    this.getCourts()
  },
  setup() {
    const { refFormObserver, getValidationState, resetForm } = formValidation()
    return { refFormObserver, getValidationState, resetForm }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
